import Details from '@/components/Details/Details';
import InfoLabel from '@/components/InfoLabel';
import { IPutAfterConfirmingBookingWorkflowRequest } from '@/types/workflows/IPutAfterConfirmingBookingWorkflowRequest';
import { Box, Checkbox, FormControl, Select } from '@chakra-ui/react';
import { t } from 'i18next';
import { UseFormReturn } from 'react-hook-form';

interface IProps {
	form: UseFormReturn<IPutAfterConfirmingBookingWorkflowRequest, any>;
	index: number;
}

export default function OptionsWebinar(props: IProps) {
	return (
		<Box display="grid" gap={6} mt={4} p={4}>
			<FormControl>
				<InfoLabel text={t('Calendar')} help={t('TimeTime will create evens in this calendar')} />
				<Select {...props.form.register(`actions.${props.index}.calendarId`)}>
					<option value="">Please select</option>
					<option value="iago@timetime.in">iago@timetime.in</option>
					<option value="iago.lastra@gmail.com">iago.lastra@gmail.com</option>
				</Select>
			</FormControl>

			<Details title="Advanced options">
				<Box display="grid" gap={6}>
					<FormControl>
						<InfoLabel text={t('Guest notifications ')} help={t('...')} />
						<Select {...props.form.register(`actions.${props.index}.guestNotificationsMode`)}>
							<option value="ALL">Always notify guests</option>
							<option value="EXTERNAL_ONLY">Send email to non gmail accounts</option>
							<option value="NONE">Do not notify guest</option>
						</Select>
					</FormControl>

					<FormControl>
						<InfoLabel text={t('Privacy')} help={t('...')} />
						<Checkbox
							isChecked={props.form.watch(`actions.${props.index}.guestsCanSeeOtherGuests`)}
							{...props.form.register(`actions.${props.index}.guestsCanSeeOtherGuests`)}
						>
							{t('Guests can see other guests')}
						</Checkbox>
					</FormControl>
				</Box>
			</Details>
		</Box>
	);
}
